import styled from 'styled-components'
import tw, { screen } from 'twin.macro'

export const Root = styled.div`
  ${tw`grid auto-rows-min gap-y-4`};
  /* Mobile-first */
  ${tw`fixed z-40 top-0 left-0 w-screen h-screen`};
  ${({ $open }) => ($open ? tw`grid` : tw`hidden`)};
  ${screen`lg`(tw`grid static w-auto h-auto p-0`)};

  @media (max-width: 62rem) {
    background-color: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);
  }
`

export const Main = styled.div`
  ${tw`overflow-auto h-screen p-8 lg:p-0 pb-36 lg:pb-0`};
  overscroll-behavior: contain;
`

export const OpenButton = styled.div`
  ${tw`lg:hidden`};
`

export const Buttons = styled.div`
  /* ${screen`lgmax`(tw`fixed bottom-0 left-0 right-0 p-8 grid grid-cols-1 gap-y-6`)}; */

  @media (max-width: 62rem) {
    ${tw`fixed bottom-0 left-0 right-0 p-8 grid grid-cols-1 gap-y-6`};
  }

  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
`

export const ApplyButton = styled.div`
  ${tw`lg:hidden`};
`
